<template>
    <DCard
        :title="__('orders.show.ordered_items')"
        :title-middle="__('orders.show.contracts')"
        :main-title-has-slot="true"
        padding
    >
        <template #titleHasSlot>
            <DSwitch
                color="success"
                variant="3d"
                :disabled="isInLoadingState"
                :checked="showSection"
                @update:checked="showCardSection"
            />
        </template>
        <DRow v-if="showSection">
            <DCol col="12">
                <DFormRow
                    :label="__('orders.show.domains')"
                >
                    <ul>
                        <li
                            v-for="(domain) in order.domains"
                            :key="domain"
                        >
                            {{ domain }}
                        </li>
                    </ul>
                </DFormRow>
            </DCol>
            <DCol col="6">
                <DTable
                    v-if="order.products && order.products.length > 0"
                    :items="order.products"
                    :fields="productFields"
                >
                    <template #price="{item}">
                        <td>{{ roundPrice(item.price - item.discounts) }}</td>
                    </template>
                </DTable>
                <DTag
                    v-else
                    :label="__('orders.show.invalid_product_data')"
                    :color="'danger'"
                />
            </DCol>
            <DCol col="6">
                <DTable
                    :items="order.contracts"
                    :fields="contractFields"
                >
                    <template #contract="{item}">
                        <td>
                            <Link
                                v-if="userPermissions.includes('contract.view')"
                                :href="contractRoute(item)"
                            >
                                {{ item.contract }}
                            </Link>
                            <span
                                v-else
                            >{{ item.contract }}</span>
                        </td>
                    </template>
                    <template #price_per_period="{item}">
                        <td>{{ roundPrice(item.price_per_period) }}</td>
                    </template>
                </DTable>
            </DCol>
        </DRow>
    </DCard>
</template>

<script setup>

import { __ } from '~@/Composables/translation'
import { computed, ref } from 'vue'
import { useForm, usePage } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const props = defineProps({
    order: {
        type: Object,
        default () {
            return {}
        }
    },
    section: {
        type: String,
        default () {
            return ''
        }
    },
    showSection: {
        type: Boolean,
        default () {
            return true
        }
    },
    userListView: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const userPermissions = computed(() => usePage().props.auth.permissions)

const productFields = [
    { key: 'name', label: __('orders.show.product_table.name') },
    { key: 'interval', label: __('orders.show.product_table.interval') },
    { key: 'price', label: __('orders.show.product_table.price') }
]

const contractFields = [
    { key: 'contract', label: __('orders.show.contract') },
    { key: 'current_product', label: __('orders.show.current_product') },
    { key: 'current_interval', label: __('orders.show.current_interval') },
    { key: 'current_price', label: __('orders.show.current_price') },
    { key: 'contract_status', label: __('orders.show.contract_status') }
]

function contractRoute (item) {
    return route('customers.customers.contracts.show', { customer: item.customer_id, contract: item.contract })
}

const emit = defineEmits(['update-list'])

const columns = ref(props.userListView)

const form = useForm({
    columns: props.userListView
})

function showCardSection (value) {
    for (const column of columns.value) {
        if (column.column === props.section) {
            column.show_column = value
        }
    }

    form.columns = flattenColumns(columns.value)

    form.post(route('settings.list-view-settings.store'))

    emit('update-list', columns.value)
}

function flattenColumns (columns) {
    if (columns.length === 0) {
        return {}
    }

    const result = {}

    for (const [key, column] of Object.entries(columns)) {
        result[key] = JSON.parse(JSON.stringify(column))
    }

    return result
}

function roundPrice (price) {
    return parseFloat(price).toFixed(2)
}
</script>

<style scoped>

</style>
